// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed-col[data-v-0080e1ba]{width:192px;border-right:1px solid #d3d3d3}.remain-col[data-v-0080e1ba]{width:calc(100% - 576px)}.view-height[data-v-0080e1ba]{height:30rem}.package-viewer[data-v-0080e1ba]{top:64px;height:calc(100% - 64px)}", ""]);
